const API_BASE_URL = `${process.env.REACT_APP_CRM_ENDPOINT_URL}/en/api/v1.0`;

// Đọc thông báo lỗi từ response (body có thể là chuỗi hoặc ReturnCode JSON)
async function extractError(response) {
  let messageText = `Đặt lịch thất bại (mã ${response.status}).`;
  try {
    const text = await response.text();
    if (text) {
      try {
        const json = JSON.parse(text);
        messageText =
          json.description || json.Description || json.message || text;
      } catch {
        messageText = text;
      }
    }
  } catch {
    // ignore
  }
  return messageText;
}

export const bookingService = {
  // apiPayload theo shape CustomerPortalAppointmentViewModel của backend
  // Chỉ HTTP 200 mới coi là thành công; còn lại ném lỗi để UI hiển thị
  async createAppointment(apiPayload) {
    const response = await fetch(
      `${API_BASE_URL}/CustomerPortal/Appointment/add`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(apiPayload),
      }
    );

    if (response.ok) {
      const json = await response.json();
      // { Data: ReturnCode { Data: <appointmentId> } } -> json.data.data
      const id = json?.data?.data;
      if (id) {
        return { id, code: id };
      }
      throw new Error("Không nhận được mã hẹn khám từ hệ thống.");
    }

    // Không phải 200 -> lỗi
    throw new Error(await extractError(response));
  },

  buildQrValue(appointment) {
    // QR chỉ encode Mã hẹn khám để quầy tiếp đón quét nhanh
    return appointment.code || "";
  },
};
